import {useAppSelector} from '@/hooks';

export function useSingleActivePosterItemId(pageId?: string): string | null {
  const currentPageId = pageId ?? window.posterEditor?.whiteboard?.getCurrentPageId();

  const singleActiveId = useAppSelector((state) => {
    if (!currentPageId) {
      return null;
    }

    if (!state.posterEditor.activeItemIds[currentPageId]) {
      return null;
    }

    return state.posterEditor.activeItemIds[currentPageId][0];
  });

  return singleActiveId ?? null;
}
